import React from 'react';
import NotasCreditoRelacionesPagosRegularesTable from './TableNotasCreditoRelacionesPagosRegulares/TableNotasCreditoRelacionesPagosRegulares';

const notasCreditoRelacionesPagosRegulares = () => {
  return <NotasCreditoRelacionesPagosRegularesTable/> ;
};

export default notasCreditoRelacionesPagosRegulares;
